import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'SMA' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'SMA', label: 'Smoothed Moving Average', pane: 'main', params: [12, 2], outputs: ['sma'], labels: ['Length', 'Weight'] })
